module.exports = __webpack_public_path__ + "static/media/10-03.ed24e3c7.png";